import SectionName from '~/constants/new-cars/SectionName';

const SectionLevelLabels: Record<SectionName, string> = {
  [SectionName.Doors]: 'Doors',
  [SectionName.ModelVersion]: 'Model Version',
  [SectionName.Options]: 'Options',
  [SectionName.Trim]: 'Trim',
  [SectionName.TruckBodyStyle]: 'Body Style',
  [SectionName.Year]: 'Year'
};

export default SectionLevelLabels;
